import { ButtonHTMLAttributes, ReactElement, ReactNode } from "react";

import {
  Button as ButtonComponent,
  Icon,
  LoadingIcon,
  Text,
  TextSubmitting,
} from "./styles";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  icon?: ReactElement;
  isSubmitting?: boolean;
  submittingMessage?: string;
  bgColor?: string;
  bordercolor?: string;
  color?: string;
  height?: string;
};

export function Button({
  children,
  icon,
  isSubmitting = false,
  submittingMessage = "",
  disabled = false,
  color = "var(--black)",
  ...rest
}: ButtonProps) {
  return (
    <ButtonComponent
      isSubmitting={isSubmitting}
      hasSubmittingMessage={submittingMessage.length > 0}
      disabled={isSubmitting || disabled}
      aria-disabled={isSubmitting || disabled}
      hasIcon={!!icon}
      color={color}
      {...rest}
    >
      {icon && !isSubmitting && <Icon data-testid="button-icon">{icon}</Icon>}
      {isSubmitting && <LoadingIcon hasText={submittingMessage.length > 0} />}
      {(!isSubmitting || submittingMessage.length === 0) && (
        <Text className="text">{children}</Text>
      )}
      {isSubmitting && submittingMessage.length > 0 && (
        <TextSubmitting>{submittingMessage}</TextSubmitting>
      )}
    </ButtonComponent>
  );
}
